import moment from 'moment';
import { omit } from 'lodash';
import { InsuredBeneficiaryModel } from './InsuredBeneficiaryModel';
const dateFormat = 'MMMM DD YYYY';
export class InsuredPersonalDetailModel {
    constructor(payload) {
        const params = omit(payload, 'insuredBeneficiaries');
        Object.assign(this, params);
        const insuredBeneficiaries = payload.insuredBeneficiaries.edges;
        this.insuredBeneficiaries = insuredBeneficiaries.map((insuredBeneficiary) => {
            return new InsuredBeneficiaryModel(insuredBeneficiary.node);
        });
    }
    get fullName() {
        return `${this.firstName} ${this.middleName ? this.middleName : ''} ${this.lastName}`;
    }
    get formattedBirthDate() {
        const birthDate = this.birthdate;
        if (!birthDate) {
            return 'None';
        }
        return moment(birthDate).format(dateFormat);
    }
    get withBeneficiaries() {
        return !!this.insuredBeneficiaries?.length;
    }
}
